<template>
    <component :is="component ? component: 'div'" v-if="component"></component>
    <div v-else></div>
</template>

<script setup lang="ts">
import {PropType} from "vue";
import {PageDataHolderFetchedWidget} from "../../../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {resolveComponent} from "#imports";
import {useNuxtApp} from "#app";

const props = defineProps({
  widget: Object as PropType<PageDataHolderFetchedWidget>
});
const {$isDesktop} = useNuxtApp();

const component = resolveComponent($isDesktop() ? "WidgetProductFilterIndexDesktop" : "WidgetProductFilterIndexPhone");
</script>
